<edp-popover
    #popSimulationComponent
    [popoverContent]="popoverContent"
    [popPlacement]="placement"
    [popBtn]="'icon-tooltip-simulation icon-edponline-Bop-025'"
>
    <ng-template #popoverContent>
        <span class="d-block simulation-description">
            {{ 'pt.edp.edponline.readings.simulation.tooltip' | translate }}</span>
    </ng-template>
</edp-popover>
